// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"b306fae8","515":"bca17df4","775":"b306fae8"}[chunkId] + ".chunk.css";
};